import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import withTranslation from "../../hocs/withTranslation";
import { getStyles } from "../../store/selectors";
import { saveProfile } from "../../store/user/actions";
import Modal from "../Modal";
import AppContainer from "../AppContainer";
import Button from "../Button";
import { EmailInput, InputGroup } from "../Inputs";
import Loader from "../Loader";
import * as styles from "./index.module.scss";

function MissingEmailView({ T, modalMode = true, onClose, ...props }) {
  const dispatch = useDispatch();

  const {
    user: {
      saveProfileState: { sending: savingSending, sent: savingSent },
    },
    app,
  } = useSelector(({ app, user }) => ({ app, user }));

  const appStyles = getStyles({ app }, props);

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(null);
  const [emailRef, setEmailRef] = useState(null);

  const onSubmit = async () => {
    if (!emailRef) return;

    emailRef.validate((error, value) => {
      if (error) {
        setEmailError(error);
        return;
      }

      dispatch(saveProfile({ email: value }));
    });
  };

  useEffect(() => {
    if (savingSent) {
      onClose();
    }
  }, [savingSent]);

  const onEmailValid = (value) => {
    setEmail(value);
    setEmailError(null);
  };

  const onEmailError = (error) => {
    setEmailError(error);
  };

  const registerEmailInput = (ref) => {
    setEmailRef(ref);
  };

  const loadingView = (
    <AppContainer.Content appStyles={appStyles} modalMode={modalMode}>
      <AppContainer.CenteredColumn>
        <h2 className={styles.Title} style={appStyles.Signup}>
          {T("Email Required")}
        </h2>
        <Loader appStyles={appStyles} />
        <strong>{T("Saving email...")}</strong>
      </AppContainer.CenteredColumn>
    </AppContainer.Content>
  );

  const missingEmailViewComponent = (
    <AppContainer.Content appStyles={appStyles} modalMode={modalMode} animate>
      <AppContainer.CenteredColumn>
        <h2 className={styles.Title} style={appStyles.Signup}>
          {T("Email Required")}
        </h2>
        <p className={styles.Description}>
          {T(
            "Please enter your email address to continue. This is required for your account."
          )}
        </p>
      </AppContainer.CenteredColumn>
      <InputGroup appStyles={appStyles} T={T}>
        <EmailInput
          refEl={registerEmailInput}
          onValid={onEmailValid}
          onError={onEmailError}
          T={T}
          appStyles={appStyles}
          initialValue={email}
          placeholder={T("Enter your email address")}
        />
      </InputGroup>
      <Button
        onClick={onSubmit}
        appStyles={appStyles}
        centered
        loading={savingSending}
        completed={savingSent}
        disabled={emailError || savingSending}
        style={{
          margin: "0 16px",
        }}
      >
        {T("Save Email")}
      </Button>
      
    </AppContainer.Content>
  );

  if (savingSending) {
    return modalMode ? (
      <Modal
        open={true}
        onClose={onClose}
        appStyles={appStyles}
        style={{ width: "100%" }}
      >
        {loadingView}
      </Modal>
    ) : (
      loadingView
    );
  }

  return modalMode ? (
    <Modal
      open={true}
      onClose={onClose}
      appStyles={appStyles}
      style={{ width: "100%" }}
    >
      {missingEmailViewComponent}
    </Modal>
  ) : (
    missingEmailViewComponent
  );
}

export default withTranslation(({ T, ...props }) => (
  <MissingEmailView T={T} {...props} />
));
